import { isBrowser } from './WebApi';
import { cookieConfig } from './cookie-config';
const { USE_SECURE_COOKIES, USE_LOCALSTORAGE } = cookieConfig;
/**
 * @private
 */
function getExpiryDate(expiresInDays = 1) {
    const expireTimestamp = Date.now() + expiresInDays * 1000 * 60 * 60 * 24;
    return new Date(expireTimestamp);
}
/**
 * Read a cookie from localStorage or document.cookie.
 */
export function readCookie(key, useLocalStorage = USE_LOCALSTORAGE) {
    if (!isBrowser) {
        return '';
    }
    if (useLocalStorage) {
        const fromLocalStorage = localStorage.getItem(key) || '';
        if (fromLocalStorage) {
            return fromLocalStorage;
        }
    }
    return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1'));
}
/**
 * Write a cookie to document.cookie and/or localStorage
 *
 * @param key The key for the cookie
 * @param value The value for the cookie
 * @param domain The domain for the cookie.  You might want to use `getRootDomain()`
 *   for this to set the cookie at the "best" domain.
 * @param expiresInDays The number of days until the cookie should expire.  Defaults to 1.
 * @param useLocalStorage Whether to use localStorage *in addition* to setting a cookie.
 *   Note that localStorage has the specific origin of the current window.location, so
 *   if you set `domain` to something more general, then other subdomains will not be able
 *   to read back from the same localStorage, but will be able to read back the cookie only.
 * @param useSecureCookies Whether to write that have SameSite=None and Secure set.  You usually want this.
 */
export function writeCookie(key, value, domain, expiresInDays = 1, useLocalStorage = USE_LOCALSTORAGE, useSecureCookies = USE_SECURE_COOKIES) {
    if (isBrowser) {
        const expires = getExpiryDate(expiresInDays).toUTCString();
        let cookieString;
        cookieString = `${key}=${encodeURIComponent(value)}`;
        cookieString += ';path=/';
        if (domain) {
            cookieString += `;domain=${domain}`;
        }
        if (expiresInDays) {
            cookieString += `;expires=${expires}`;
        }
        if (useSecureCookies &&
            window.location.protocol === 'https:' &&
            // 20200303
            // This only detects safari on desktop
            // (already fixed)
            // https://bugs.webkit.org/show_bug.cgi?id=198181
            // TODO: Remove this when market share with this
            // bug is low.. maybe 2020-08-ish.
            // biome-ignore lint/suspicious/noExplicitAny: <explanation>
            window.safari === undefined) {
            cookieString += ';SameSite=None;Secure';
        }
        document.cookie = cookieString;
        if (useLocalStorage) {
            if (value === '') {
                localStorage.removeItem(key);
            }
            else {
                localStorage.setItem(key, value);
            }
        }
    }
}
/**
 * Delete a cookie
 */
export function deleteCookie(key, domain) {
    writeCookie(key, '', domain, -1);
}
//# sourceMappingURL=cookie.js.map